import React from 'react'
import '../../assets/css/loader.css'

const Loader = () => {
    return ( 
        <div className="d-flex justify-content-center align-items-center py-5" style={{ 
            minHeight: '50vh',
            position: 'relative'
        }}>
            <div className="loader" style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}>
                <div className="loaderCircle">
                    <div className="loaderCircle-anim">
                        <div className="loaderCircle-anim-bounce">
                            <div className="loaderCircle-anim-flop">
                                <div className="loaderCircle-circle"></div>
                            </div>
                        </div>
                    </div>
                    <div className="loaderCircle-floor">
                        <div className="loaderCircle-floor-shadow"></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Loader